import { html, LitElement } from 'lit';
import { FsIcon } from '@cof/fs-icon-wc/fs-icon.js';
import { TagKey } from '@cof/tag-catalog-fs-esign-mfe';
import '@cof/fs-button-wc/fs-button.js';
import { fs16LinkDownload } from '@cof/fs-icons';
import { DownloadService } from '../../shared/services/download/download.service.js';
import { stratum } from '../../../constants/stratum.js';
import {
  TitleType,
  MICHIGAN_BORROWER_DL_STATE,
  DC_BORROWER_DL_STATE,
  BORROWER_DL_STATE
} from '../etitle.config.js';
import { EtitleDownloadStyles } from './etitle-download.styles.js';
import { AdditionalInfoController } from '../controller/additional-info.controller.js';
import { DebugService } from '../../shared/services/debug.service.js';

FsIcon.add(fs16LinkDownload);

export class EtitleDownloadComponent extends LitElement {
  static properties = {
    etitleType: {
      type: String,
      attribute: 'etitle-type'
    },
    loading: {
      type: Boolean,
      state: true
    }
  };

  static styles = [EtitleDownloadStyles];

  constructor() {
    super();
    this.etitleType = '';
    this.additionalInfoController = new AdditionalInfoController(this);
    this.debugService = new DebugService('EtitleDownloadComponent');
  }

  async downloadETitle() {
    this.loading = true;
    const tagMap = {
      [TitleType.PoA]: {
        review: TagKey.POA__REVIEW_FULL_POWER_OF_ATTORNEY,
        success: TagKey.POA_POA_DOCUMENT_SUCCESSFULLY_DOWNLOADED,
        failure: TagKey.POA_POA_DOCUMENT_FAILED_TO_DOWNLOAD
      },
      [TitleType.TitleAuth]: {
        review: TagKey.TITLE_AUTHORIZATION_REVIEW_FULL_TITLE_AUTHORIZATION,
        success:
          TagKey.TITLE_AUTHORIZATION_TITLE_AUTHORIZATION_DOCUMENT_SUCCESSFULLY_DOWNLOADED,
        failure:
          TagKey.TITLE_AUTHORIZATION_TITLE_AUTHORIZATION_DOCUMENT_FAILED_TO_DOWNLOAD
      },
      [TitleType.TitleApp]: {
        review: TagKey.TITLE_APPLICATION_REVIEW_FULL_TITLE_APPLICATION,
        success:
          TagKey.TITLE_APPLICATION_TITLE_APPLICATION_DOCUMENT_SUCCESSFULLY_DOWNLOADED,
        failure: TagKey.TITLE_APPLICATION_TITLE_APPLICATION_FAILED_TO_DOWNLOAD
      },
      [TitleType.SecurityAgreement]: {
        review: TagKey.SECURITY_AGREEMENT_REVIEW_FULL_SECURITY_AGREEMENT,
        success:
          TagKey.SECURITY_AGREEMENT_SECURITY_AGREEMENT_DOCUMENT_SUCCESSFULLY_DOWNLOADED,
        failure: TagKey.SECURITY_AGREEMENT_SECURITY_AGREEMENT_FAILED_TO_DOWNLOAD
      }
    };

    const tags = tagMap[this.etitleType];
    if (tags) {
      stratum.publishTag(tags.review);
    }

    const additionalInfo = this.additionalInfoController.additionalInfo.map(
      inputData => ({
        fieldType: [MICHIGAN_BORROWER_DL_STATE, DC_BORROWER_DL_STATE].includes(
          inputData.fieldName
        )
          ? BORROWER_DL_STATE
          : inputData.fieldName,
        fieldValue: inputData.value
      })
    );

    try {
      await DownloadService.downloadEtitle(additionalInfo, false);
      if (tags) {
        stratum.publishTag(tags.success);
      }
    } catch (ex) {
      this.debugService.error('Unable to download eTitle', ex);
      if (tags) {
        stratum.publishTag(tags.failure);
      }
    } finally {
      this.loading = false;
    }
  }

  render() {
    return html` <div class="etitle-download">
      <fs-button
        @click="${this.downloadETitle}"
        icon-position="leading"
        ghost
        compact
        ?loading="${this.loading}">
        <fs-icon slot="button-icon" icon="fs-16-link-download"> </fs-icon>
        Review full ${this.etitleType}
      </fs-button>
    </div>`;
  }
}

customElements.define('etitle-download', EtitleDownloadComponent);
